import api from "@/api/api";
import { STATUS_HTTP } from "@/api/statusHTTP";
import { iniciarRequisicao, logout } from "@/helpers/index.js";

const BASE_URL = '/compra/cotacao/';

export const atualizarProdutosCotacaoPedido = async (params) => {
  const URL = BASE_URL + 'atualizar-produtos-cotacao-pedido';

  const { data, status } = await api.post(URL, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return;
}

export const buscarProdutosCotacaoAtual = async (params) => {
  const URL = BASE_URL + 'buscar-produtos-cotacao-atual';

  const { data, status } = await api.post(URL, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.dados;
}

export const deletarMultiplosItensCotacaoPedido = async (params) => {
  const URL = BASE_URL + 'deletar-multiplos-item-cotacao-pedido';

  const { data, status } = await api.post(URL, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.cotacao;
}

export const deletarItemCotacaoPedido = async (params) => {
  const URL = BASE_URL + 'deletar-item-cotacao-pedido';

  const { data, status } = await api.post(URL, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.cotacao;
}

export const abrirCotacaoPedido = async (params) => {
  const URL = BASE_URL + 'abrir-cotacoes-pedido';

  const { data, status } = await api.post(URL, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.cotacao;
}

export const buscarCotacaoPedido = async (id_pedido, id_cotacao) => {
  const URL = BASE_URL + 'buscar-cotacoes-pedido/' + (id_pedido || 0) + '/' + id_cotacao;

  const config = {
    headers: iniciarRequisicao()
  };

  const { data, status } = await api.get(URL, config).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.cotacao;
}

export const atualizarQuantidadePrecoCotacao = async (params) => {
  const URL = BASE_URL + 'atualizar-quantidade-produto-cotacoes-pedido';

  const { data, status } = await api.post(URL, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.cotacao;
}

export const atualizarQuantidadePrecoCarrinho = async (params) => {
  const URL = BASE_URL + 'atualizar-quantidade-preco-carrinho';

  const { data, status } = await api.post(URL, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.dados;
}

export const atualizarMultiplasQuantidadePrecoCarrinho = async (params) => {
  const URL = BASE_URL + 'atualizar-multiplas-quantidade-preco-carrinho';

  const { data, status } = await api.post(URL, params, { headers: iniciarRequisicao() }).catch(logout);

  if (status !== STATUS_HTTP.OK) logout();

  localStorage.token = data.token;
  return data.dados;
}

